"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MstrStageActivityTemplate = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let MstrStageActivityTemplate = class MstrStageActivityTemplate {
    constructor(policyTypeId, orgId, stageId, activityId, approval, mandatory, activityKey, opportunityTable, leadRoleId, createdBy, updatedBy) {
        this.policyTypeLid = policyTypeId;
        this.orgId = orgId;
        this.stageId = stageId;
        this.activityId = activityId;
        this.approval = approval;
        this.mandatory = mandatory;
        this.activityKey = activityKey;
        this.opportunityTable = opportunityTable;
        this.leadRoleId = leadRoleId;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.MstrStageActivityTemplate = MstrStageActivityTemplate;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "policyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "org_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "orgId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "stage_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "stageId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "activity_key",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], MstrStageActivityTemplate.prototype, "activityKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 10 }),
    tslib_1.__metadata("design:type", String)
], MstrStageActivityTemplate.prototype, "approval", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 10 }),
    tslib_1.__metadata("design:type", String)
], MstrStageActivityTemplate.prototype, "mandatory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_role_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "leadRoleId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_table", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrStageActivityTemplate.prototype, "opportunityTable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrStageActivityTemplate.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], MstrStageActivityTemplate.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], MstrStageActivityTemplate.prototype, "updatedAt", void 0);
exports.MstrStageActivityTemplate = MstrStageActivityTemplate = tslib_1.__decorate([
    (0, typeorm_1.Entity)("mstr_stage_activity_template"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, String, String, String, String, Number, Number, Number])
], MstrStageActivityTemplate);
